import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ConfirmationService, FilterMatchMode } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Nip } from '../_models/nip';
import { MessService } from '../_services/mess-service.service';
import { NipService } from '../_services/nip.service';
import { Table } from 'primeng/table';
import { PackageType } from '../_models/package_type';
import { PackageTypesService } from '../_services/package-types.service';
import { AuthenticationService } from '../_services/authentication.service';

@Component({
  selector: 'app-nip',
  templateUrl: './nip.component.html',
  styleUrls: ['./nip.component.scss'],
})
export class NipComponent implements OnInit, OnDestroy {
  loading: boolean = true;

  // Users that can create NIP
  authUsersForAdd = ['admin', 'prodavac'];
  isUserAuthForAdd: boolean;

  nips: Nip[];
  nipsClone: Nip[];

  packageTypes: PackageType[];
  packageTypesSub: Subscription;

  globalSearchField;
  packageTypeSearchField;

  rangeDatesTo;
  rangeDatesFrom;

  dateFilters: any;
  dateFiltersTo: any;

  rangeDates;
  filterClickCount: number = 0;
  fDateFrom;
  fDateTo;

  rangeDatesCreatedAt;
  CreatedAtfilterClickCount: number = 0;
  fDateCreatedAtFrom;
  fDateCreatedAtTo;

  subscriptions: Subscription[] = [];

  constructor(
    private nipsService: NipService,
    private confirmationService: ConfirmationService,
    private messService: MessService,
    private packageTypesService: PackageTypesService,
    private authService: AuthenticationService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    // * Check is user authorized to edit main fields
    this.isUserAuthForAdd = this.authService.isAuthorized(this.authUsersForAdd);

    this.subscriptions.push(
      this.nipsService.getAllNip().subscribe((responseData) => {
        this.nips = responseData;
        this.nipsClone = responseData;

        this.nips.forEach((nip) => {
          nip.deadline = new Date(nip.deadline);
          nip.created_at = new Date(nip.created_at);
        });
        this.loading = false;
      })
    );

    this.subscriptions.push(
      this.packageTypesService
        .getAllPackageTypes()
        .subscribe((productTypes) => {
          this.packageTypes = productTypes;
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // * Edit/Delete === //
  onEditNip(nipData: Nip) {
    this.nipsService.updateNipData.next(nipData);
  }

  onDeleteNip(event: Event, nipId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete NIP?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.nipsService.deleteNip(nipId).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Obrisali ste NIP.',
              });
              this.updatePackageList();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }

  // * Update list after delete === //
  private updatePackageList() {
    this.loading = true;
    this.subscriptions.push(
      this.nipsService.getAllNip().subscribe((responseData) => {
        this.nips = responseData;
        this.loading = false;
      })
    );
  }

  // * Helpers === //
  clearFilters(field) {
    this.nips = this.nipsClone;
    this[field] = null;
  }

  filterDateDeadline(event, field) {
    this.filterClickCount++;
    // @param filterClickCount broji koliko puta je kliknuto na taj filter
    if (this.filterClickCount % 2 != 0) {
      // Prvi put kad se klikne tad se bira datum OD
      this.fDateFrom = event;
      return;
    } else {
      // Drugi put se bira datum DO
      this.fDateTo = event;
      if (this.fDateFrom > this.fDateTo) {
        // Ako je datum OD veci od datuma DO zatvara se filter, izbacuje gresku i resetuje tabelu na pocetno stanje
        this.nips = this.nipsClone;
        this.rangeDates = null;
        this.rangeDatesCreatedAt = null;
        this.messService.add({
          severity: 'error',
          title: 'Greška',
          detail: 'Datum OD mora biti manji od datuma DO!',
        });
        return;
      }
    }
    // Filriranje OD - DO datuma
    this.nips = this.nipsClone.filter((val) => {
      return val[field] >= this.fDateFrom && val[field] <= this.fDateTo;
    });
  }

  filterDateCreatedAt(event, field) {
    this.CreatedAtfilterClickCount++;
    // @param filterClickCount broji koliko puta je kliknuto na taj filter
    if (this.CreatedAtfilterClickCount % 2 != 0) {
      // Prvi put kad se klikne tad se bira datum OD
      this.fDateCreatedAtFrom = event;
      return;
    } else {
      // Drugi put se bira datum DO
      this.fDateCreatedAtTo = event;
      if (this.fDateCreatedAtFrom > this.fDateCreatedAtTo) {
        // Ako je datum OD veci od datuma DO zatvara se filter, izbacuje gresku i resetuje tabelu na pocetno stanje
        this.nips = this.nipsClone;
        this.rangeDates = null;
        this.rangeDatesCreatedAt = null;
        this.messService.add({
          severity: 'error',
          title: 'Greška',
          detail: 'Datum OD mora biti manji od datuma DO!',
        });
        return;
      }
    }
    // Filriranje OD - DO datuma
    this.nips = this.nipsClone.filter((val) => {
      return (
        val[field] >= this.fDateCreatedAtFrom &&
        val.created_at <= this.fDateCreatedAtTo
      );
    });
  }
}
